import React from "react"
import Config from "../../../gatsby-config"
import PropTypes, { arrayOf } from "prop-types"
import Logo from "../../assets/img/faq/icon/icons-512.png"
import { GetImageURL } from "../../utils/utilities"
import { Script } from "gatsby"

function SEO2({
  description,
  lang = 'en',
 //meta = [""],
  image: metaImage,
  title,
  ogType='webpage',
  url,
  type='WebPage',
  author='Marc Aubanel',
  date,
  city,
  state,
  address,
  location,
  eventStatus,
  endDate,
  eventAttendanceMode,
  organizerType,
  organizer,
  organizerUrl,
  eventUrl,
  performer,
  keywrds=["dmae", "lsu", "louisiana state university"],
  numberofArticles=0,
  listOfArticles=[],
  video,
  canonical
}) {
  const data = Config.siteMetadata
  const metaDescription = description || data.description
  const keywords = keywrds || data.keywords
  const image = metaImage && metaImage.src ? `${metaImage.src}` : null
  const fullUrlPath = data.siteUrl + url
  let schemaEntityType = {}
  if (type === "NewsArticle") {
    schemaEntityType = {
      "@context": "http://schema.org",
      "@type": type,
      author: author,
      datePublished: date,
      headline: title,
      image: image,
      mainEntityOfPage: {
        "@type": "Webpage",
        url: fullUrlPath,
      },
      publisher: {
        "@type": "EducationalOrganization",
        name: data.publisher,
        logo: {
          "@type": "ImageObject",
          url: data.siteUrl + Logo.toString(),
        },
        telephone: data.telephone,
        email: data.mainEmail,
        geo: {
          "@type": "GeoCoordinates",
          latitude: data.latitude,
          longitude: data.longitude,
        },
        address: {
          "@type": "PostalAddress",
          streetAddress: data.streetAddress,
          addressLocality: data.city,
          addressRegion: data.state,
          postalCode: data.zip,
        },
      },
      dateModified: data.date,
    }
  } else if (type === "BlogPosting") {
    schemaEntityType = {
      "@context": "http://schema.org",
      "@type": type,
      author: data.author,
      datePublished: data.date,
      dateModified: data.dateModified,
      headline: data.title,
      image: image,
      mainEntityOfPage: {
        "@type": "WebPage",
        url: fullUrlPath,
      },
      publisher: {
        "@type": "EducationalOrganization",
        name: data.department + "Program",
        logo: {
          "@type": "ImageObject",
          url: data.siteUrl + Logo.toString(),
        },
        telephone: data.telephone,
        email: data.mainEmail,
        geo: {
          "@type": "GeoCoordinates",
          latitude: data.latitude,
          longitude: data.longitude,
        },
        address: {
          "@type": "PostalAddress",
          streetAddress: data.streetAddress,
          addressLocality: data.city,
          addressRegion: data.state,
          postalCode: data.zip,
        },
      },
    }
  } else if (type === "ProjectsList") {
    const topSchema = {
      "@context": "http://schema.org",
      "@type": "ItemList",
      url: fullUrlPath,
      numberOfItems: numberofArticles,
    }

    let collectionOfArticles = []
    listOfArticles.forEach(element => {
      let image = GetImageURL(
        element.node.frontmatter?.project_pic,
        element.node?.childUtube,
        element.node?.childrenOembedVim
      ).src

      let articleObject = {}

      articleObject = {
        "@type": "BlogPosting",
        headline: element.node.frontmatter.title,
        datePublished: element.node.frontmatter.date,
        author: element.node.frontmatter.author,
        image: image,
      }
      collectionOfArticles.push(articleObject)
    })
    const temp = { itemListElement: collectionOfArticles }
    schemaEntityType = Object.assign(topSchema, temp)
  } else if (type === "Event" && location !== "Online") {
    schemaEntityType = {
      "@context": "http://schema.org",
      "@type": type,
      location: {
        "@type": "Place",
        address: {
          addressLocality: city,
          addressRegion: state,
          streetAddress: address,
        },
        name: location,
      },
      name: title,
      startDate: date,
      endDate: endDate,
      description: description,
      image: image,
      eventStatus: eventStatus,
      eventAttendanceMode: eventAttendanceMode,
      organizer: {
        "@type": organizerType,
        name: organizer,
        url: organizerUrl,
      },
      url: eventUrl,
      performer: performer,
    }
  } 
  else if (type === "Event" && location === "Online") {
    schemaEntityType = {
      "@context": "http://schema.org",
      "@type": type,
      location: {
        "@type": "VirtualLocation",
        url: organizerUrl
      },
      name: title,
      startDate: date,
      endDate: endDate,
      description: description,
      image: image,
      eventStatus: eventStatus,
      eventAttendanceMode: eventAttendanceMode,
      organizer: {
        "@type": organizerType,
        name: organizer,
        url: organizerUrl,
      },
      url: eventUrl,
      performer: performer,
    }
  } 
  else if (type === "WebPage") {
    schemaEntityType = {
      "@context": "http://schema.org",
      "@type": "EducationalOrganization",
      image: image,
      department: data.department,
      logo: data.siteUrl + Logo.toString(),
      mainEntityOfPage: {
        "@type": type,
      },
      parentOrganization: "Louisiana State University (LSU)",
      name: data.department + " Program",
      telephone: data.telephone,
      email: data.mainEmail,
      geo: {
        "@type": "GeoCoordinates",
        latitude: data.latitude,
        longitude: data.longitude,
      },
      address: {
        "@type": "PostalAddress",
        streetAddress: data.streetAddress,
        addressLocality: data.city,
        addressRegion: data.state,
        postalCode: data.zip,
      },
      url: fullUrlPath,
    }
  } else if (type === "EventsList") {
    const topSchema = {
      "@context": "http://schema.org",
      "@type": "ItemList",
      url: fullUrlPath,
      numberOfItems: numberofArticles,
    }
    let collectionOfArticles = []

    listOfArticles.forEach(element => {
      let image = GetImageURL(
        element.node.frontmatter?.poster,
        element.node?.childUtube,
        element.node?.childrenOembedVim
      ).src

      let articleObject = {}

      articleObject = {
        "@type": "Event",
        name: element.node.frontmatter.title,
        startDate: element.node.frontmatter.date,
        description: element.node.excerpt,
        image: image,
      }
      collectionOfArticles.push(articleObject)
    })
    const temp = { itemListElement: collectionOfArticles }
    schemaEntityType = Object.assign(topSchema, temp)
  } else if (type === "NewsList") {
    const topSchema = {
      "@context": "http://schema.org",
      "@type": "ItemList",
      url: fullUrlPath,
      numberOfItems: numberofArticles,
    }
    let collectionOfArticles = []

    listOfArticles.forEach(element => {
      let image = GetImageURL(
        element.node.frontmatter?.news_pic,
        element.node?.childUtube,
        element.node?.childrenOembedVim
      ).src
      let articleObject = {}

      articleObject = {
        "@type": "NewsArticle",
        author: element.node.frontmatter.author,
        datePublished: element.node.frontmatter.date,
        headline: element.node.frontmatter.title,
        image: image,
        url: data.siteUrl + element.node.slug,
        publisher: {
          name: "DMAE LSU",
        },
      }
      collectionOfArticles.push(articleObject)
    })
    const temp = { itemListElement: collectionOfArticles }
    schemaEntityType = Object.assign(topSchema, temp)
  }

  const finalSchema = JSON.stringify(schemaEntityType, null, 2)

  return (
    <>
      <title>{`${title} |  ${data.fullTitle}`}</title>
      <meta name="description" content={`${metaDescription}`} />
      <meta name="keywords" content={`${keywords.join(",")}`} />
      <meta property="og:title" content={`${title} |  ${data.fullTitle}`} />
      <meta property="og:description" content={`${metaDescription}`} />
      <meta property="og:type" content={"website" && `${ogType}`} />
      <meta property="og:url" content={`${fullUrlPath}`} />
      <meta property="fb:app_id" content={`${data.facebookAppId}`} />
      <meta name="twitter:creator" ent={`${data.author}`} />
      <meta name="twitter:title" ent={`${title}`} />
      <meta name="twitter:description" ent={`${metaDescription}`} />
      <meta name="twitter:domain" ent={`${fullUrlPath}`} />
      <meta name="twitter:site" ent={`${data.twitter}`} />
      {image !== "" && (
        <>
          <meta property="og:image" content={`${image}`} />
          <meta property="og:image:width" content={`${metaImage.width}`} />
          <meta property="og:image:height" content={`${metaImage.height}`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image" content={`${image}`} />
        </>
      )}
      {video !== "" && (
        <>
          <meta name="twitter:card" content="player" />
          <meta name="twitter:player" content={`${video}`} />
          <meta name="twitter:player:width" content="640" />
          <meta name="twitter:player:height" content="390" />
          <meta property="og:video" content={`${video}`} />
          <meta property="og:video:secure_url" content={`${video}`} />
          <meta property="og:video:type" content="video/mp4" />
          <meta property="og:video:width" content="640" />
          <meta property="og:video:height" content="390" />
        </>
      )}
      { (canonical) && (
        <>
        <link rel = "canonical" href={`${canonical}`}/> 
        </>
      )

      }

      <script type="application/ld+json">{finalSchema}</script>

      <script>
        {
          `function gtag_report_conversion(url) {
        var callback = function () {
        if (typeof(url) != 'undefined') {
        window.location = url;
      }
      };
        gtag('event', 'conversion', {
        'send_to': 'AW-952596235/3teCCO6n0pQBEIvuncYD',
        'event_callback': callback
      });
        return false;
      }
      `}
      </script>
      {/* <!-- Begin Consent Overlay --> */}

      <link
        href="https://www.lsu.edu/_resources/css/consent.css"
        rel="stylesheet"
        type="text/css"
      />

      <noscript>
        {`
          <link
            href="https://www.lsu.edu/_resources/css/consent.css"
            rel="stylesheet"
            type="text/css"
          />
          `}
      </noscript>
      <script type="text/javascript" src="https://www.lsu.edu/_resources/js/consent.js"></script> 

      <Script type="text/javascript">{`// <![CDATA[
                window.addEventListener("load", function(){
                  window.cookieconsent.initialise({
                    "palette": {
                    "popup": {
                    "background": "#fdd023",
                    "text": "#333333"
                    },
                    "button": {
                    "background": "#efefef",
                    "text": "#461d7c"
                    }
                    },
                    "content": {
                    "link": "LSU Privacy Statement.",
                    "href": "/privacy/"
                    }
                  })});
              // ]]>
    `}</Script>
      {/* <!-- End Consent Overlay --> */}
    </>
  )
}



SEO2.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  //meta: PropTypes.arrayOf(PropTypes.object).isRequired,
  ogType: PropTypes.string.isRequired,
  description: PropTypes.string,
  lang: PropTypes.string,
  author: PropTypes.string,
  date: PropTypes.string,
  endDate: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  address: PropTypes.string,
  eventStatus: PropTypes.string,
  eventAttendanceMode: PropTypes.string,
  organizerType: PropTypes.string,
  organizer: PropTypes.string,
  organizerUrl: PropTypes.string,
  eventUrl: PropTypes.string,
  performer: PropTypes.string,
  keywrds: PropTypes.array,
  numberofArticles: PropTypes.number,
  listOfArticles: arrayOf(PropTypes.object),
  video: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
}

export default SEO2
